module.exports = __webpack_public_path__ + "assets/c96b137532409f19eac7007753d6957b.svg";